import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class PersonalDataCategoryApi extends BaseApi {
    constructor(client) {
        super(client, '/personal-data-category');
    }

    async getDropdown() {
        try {
            const response = await this.client.get(`${this.basePath}/dropdown/params`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
